import { ApolloClient } from "@apollo/client/core";
import { InMemoryCache } from "@apollo/client/cache";
import { ApolloProvider } from "@apollo/client/react";
import { useSelector } from "react-redux";

export function ApolloProdviderClient({ children }) {
  const { isSignedIn } = useSelector((state) => state.loginSlice);

  const client = new ApolloClient({
    uri: `https://backend.hettichindiaonline.com/pub/graphql`,
    cache: new InMemoryCache(),
    headers: {
      Authorization: isSignedIn ? `Bearer ${isSignedIn}` : null,
    },
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
